<template>
  <div
    id="map-contaier-to-fullscreen"
    @mouseout="toggleInterationMouseWheelZoom"
  >
    <div
      :class="newFullscreen ? 'map-fullscreen' : 'map-not-fullscreen'"
      :style="changedMenu ? '' : 'background-color: transparent'"
    >
      <new-map-menu
        ref="refNewMapMenu"
        :olMap="map"
        :basin="location"
        :basinIcon="basinIcon"
        :overlaysGroup="overlaysGroup"
        :isFullscreen="newFullscreen"
        @changeMenu="changedMenu = $event"
        @attribution="getAttribution"
        @changeEnabledSublayer="changeEnabledSublayer($event)"
        @changeOpacitySublayer="changeOpacitySublayer($event)"
        @changeBBOXMap="setMapbbox($event)"
      >
      </new-map-menu>
    </div>
    <div
      :id="mapId"
      :style="`z-index: 0; position: relative; width: 100%; height:${
        newFullscreen ? '100vh' : mapHeight
      }`"
    >
      <div id="popup" class="ol-popup" style="z-index: 9999">
        <a
          hrefF="#"
          id="popup-closer"
          class="ol-popup-closer"
          style="color: #fff"
        ></a>
        <div id="popup-content"></div>
      </div>
      <div class="map-sidebar">
        <div class="ol-zoom ol-unselectable ol-control">
          <v-tooltip right color="primary">
            <template v-slot:activator="{on, attrs}">
              <v-btn
                x-small
                width="22px"
                min-width="0px"
                @click="toggleFullscreen"
                color="#FFF"
                v-bind="attrs"
                v-on="on"
                class="mb-2"
              >
                <v-icon dark small
                  >{{
                    newFullscreen ? 'mdi-fullscreen-exit' : 'mdi-fullscreen'
                  }}
                </v-icon>
              </v-btn>
            </template>
            <span>{{
              newFullscreen ? 'Sair da tela cheia' : 'Entrar em tela cheia'
            }}</span>
          </v-tooltip>

          <v-tooltip right color="primary">
            <template v-slot:activator="{on, attrs}">
              <v-btn
                x-small
                width="22px"
                min-width="0px"
                geomtype="LineString"
                @click="toggleRuler('LineString')"
                :color="typeSelected === 'LineString' ? 'primary' : '#FFF'"
                v-bind="attrs"
                v-on="on"
              >
                <v-icon dark small>mdi-ruler</v-icon>
              </v-btn>
            </template>
            <span>{{
              typeSelected === 'LineString'
                ? 'Desligar régua distâncias'
                : 'Ligar régua distâncias'
            }}</span>
          </v-tooltip>
          <v-tooltip right color="primary">
            <template v-slot:activator="{on, attrs}">
              <v-btn
                x-small
                width="22px"
                min-width="0px"
                geomtype="Polygon"
                @click="toggleRuler('Polygon')"
                :color="typeSelected === 'Polygon' ? 'primary' : '#FFF'"
                v-bind="attrs"
                v-on="on"
              >
                <v-icon dark small>mdi-ruler-square</v-icon>
              </v-btn>
            </template>
            <span>{{
              typeSelected === 'Polygon'
                ? 'Desligar régua áreas'
                : 'Ligar régua áreas'
            }}</span>
          </v-tooltip>
        </div>
      </div>
      <div class="map-bottom-bar">
        <v-card light class="pa-2 elevation-3" width="100%">
          <div class="d-flex align-center">
            <div class="d-flex align-center atribution-text">
              <v-tooltip top color="black">
                <template v-slot:activator="{on, attrs}">
                  <v-icon color="secondary lighten-1" v-bind="attrs" v-on="on"
                    >mdi-information-outline</v-icon
                  >
                </template>
                <strong v-html="attribution"></strong>
              </v-tooltip>
              <span class="ml-1">Atribuições do mapa</span>
            </div>
            <div class="d-flex align-center scale-line-text">
              <span class="pl-3" id="mouse-position"></span>
              <span class="pl-3" id="scale-line"></span>
            </div>
          </div>
        </v-card>
      </div>
    </div>
  </div>
</template>

<script>
import 'ol/ol.css';
import Map from 'ol/Map';
import View from 'ol/View';
import {Vector as VectorLayer} from 'ol/layer';
import {Vector as VectorSource} from 'ol/source';
import {
  defaults as defaultControls,
  ScaleLine,
  MousePosition,
} from 'ol/control';

// imports for rule
import Draw from 'ol/interaction/Draw';
import Overlay from 'ol/Overlay';
import {Circle as CircleStyle, Fill, Stroke, Style} from 'ol/style';
import {LineString} from 'ol/geom';
import {getArea, getLength} from 'ol/sphere';
// imports for rule

import {format as formatCoordinate} from 'ol/coordinate';
import {
  getSublayers,
  getGroupLayers,
  getBaseLayerEsri,
} from '@/ol-maps/factory';
import {getCenter} from 'ol/extent';
import {configZoom} from '@/ol-maps/functions';
import {loadFeatures} from '@/api/geosimepar/features.api';
import {managementRoleBBOX} from '../../helpers/authorization';
import NewMapMenu from '@/components/common/NewMapMenu/NewMapMenu';
import {LOCAL_STORAGE_MODAL_MAP_INFO} from '../../helpers/local_storage_constants';
export default {
  name: 'WaterSupplyMap',
  props: {
    mapId: {
      type: String,
      default: 'map',
    },
    layers: {
      required: true,
    },
    location: {
      default: undefined,
    },
    basinIcon: {
      default: () => ({name: 'icon-infohidro-bacia', color: '#69D7A3'}),
    },
    searchResult: {
      type: String,
    },
    showMapMenu: {
      type: Boolean,
      default: true,
    },
    mapHeight: {
      type: String,
      default: '485px',
    },
  },
  /*LoadingAnimation,*/
  components: {NewMapMenu /* MapMenu */},
  data: () => ({
    attribution:
      'Tiles &copy; <a class="secondary--text" href="https://services.arcgisonline.com/ArcGIS/rest/services/World_Topo_Map/MapServer">ArcGIS</a>',
    initialCenter: {
      center: [-50.97197, -24.628277],
      zoom: 7,
      minZoom: 7,
    },
    view: undefined,
    map: undefined,
    overlaysGroup: [],
    tooltipParams: [],
    flag: undefined,
    changedMenu: false,
    gotSearchUrl: false,

    type: 'LineString',
    typeSelected: '',
    measure: false,
    draw: null,
    vector_layer: null,
    dialog: false,
    olFullScreen: false,
    keyModal: LOCAL_STORAGE_MODAL_MAP_INFO,
    isMapFullscreen: false,
    newFullscreen: false,
  }),
  watch: {
    searchResult(url) {
      if (url && this.map && this.view) {
        this.getSearchResult(url);
      }
    },
  },
  computed: {
    currentUserRoles() {
      const currentUser = this.$store.getters.currentUser;
      if (!currentUser) return [];
      const {roles} = currentUser.attributes;
      if (roles) {
        const listRoles = Array.isArray(roles) ? roles : [roles];
        return listRoles;
      }
      return [];
    },
    managementRole() {
      return managementRoleBBOX(this.currentUserRoles);
    },
  },
  methods: {
    toggleRuler(value) {
      this.clearMeasurements();
      let prevType = this.type;
      this.type = value;
      this.measure = !this.measure;
      if (prevType != value) {
        this.measure = true;
      }
      if (this.measure) {
        this.addInterecationRuler(value);
        this.typeSelected = value;
      }
    },
    async initialize() {
      const container = document.getElementById('popup');
      container.style.visibility = 'hidden';
      container.style.display = 'none';
      this.overlaysGroup = await getSublayers(this.layers);

      await this.initializeMap();
    },
    async getAttribution(attribution) {
      this.attribution = attribution;
    },
    async initializeMap() {
      this.view = new View({
        projection: 'EPSG:4326',
        ...this.initialCenter,
        rotation: 0,
      });

      // create vector layer
      let source = new VectorSource();
      let vector = new VectorLayer({
        source: source,
      });

      this.map = new Map({
        controls: defaultControls({attribution: false}).extend([
          new ScaleLine({
            units: 'metric',
            className: 'ol-scale-line-inner',
            target: document.getElementById('scale-line'),
            minWidth: 50,
            maxWidth: 100,
            minHeight: 50,
            maxHeight: 100,
          }),
          new MousePosition({
            coordinateFormat: (coordinate) => {
              return formatCoordinate(coordinate, '{x}°, {y}°', 2);
            },
            projection: 'EPSG:4326',
            className: 'custom-mouse-position',
            target: document.getElementById('mouse-position'),
            undefinedHTML: '',
          }),
        ]),
        target: this.mapId,
        layers: [vector],
        view: this.view,
      });

      let grouplayers = [];
      grouplayers.push({
        layers: [
          getBaseLayerEsri('WorldTopoMap', true),
          getBaseLayerEsri('WorldImagery', false),
        ],
      });
      getGroupLayers(this.map, grouplayers);
      getGroupLayers(this.map, this.overlaysGroup);
      this.map.on('pointermove', (e) => {
        this.$emit('mapPointerMove', e);
      });
      this.map.on('click', (e) => {
        this.$emit('mapClick', e);
      });
      this.map.on('dblclick', () => {
        this.map
          .getInteractions()
          .getArray()
          .forEach((interaction, i) => {
            if (i === 7) {
              interaction.values_.active = true;
            }
          });
      });

      this.onMapReady();

      this.toggleInterationMouseWheelZoom();

      // For ruler
      const vector_source = new VectorSource({
        projection: this.map.getView().projection,
      });

      this.vector_layer = new VectorLayer({
        source: vector_source,
        style: new Style({
          fill: new Fill({
            color: 'rgba(255, 255, 255, 0.2)',
          }),
          stroke: new Stroke({
            color: '#ffcc33',
            width: 2,
          }),
          image: new CircleStyle({
            radius: 7,
            fill: new Fill({
              color: '#ffcc33',
            }),
          }),
        }),
      });
      this.map.addLayer(this.vector_layer);

      const el = document.getElementById('map-contaier-to-fullscreen');
      el.addEventListener('fullscreenchange', this.fullscreenchanged);
    },
    addInterecationRuler(geomType) {
      this.removeInteractions();

      this.draw = new Draw({
        type: geomType,
        source: this.vector_source,
        stopClick: true,
        style: new Style({
          fill: new Fill({
            color: 'rgba(255, 255, 255, 0.2)',
          }),
          stroke: new Stroke({
            color: 'rgba(0, 0, 0, 0.5)',
            lineDash: [10, 10],
            width: 2,
          }),
          image: new CircleStyle({
            radius: 5,
            stroke: new Stroke({
              color: 'rgba(0, 0, 0, 0.7)',
            }),
            fill: new Fill({
              color: 'rgba(255, 255, 255, 0.2)',
            }),
          }),
        }),
      });
      this.draw.on('drawstart', this.onDrawStart);
      this.draw.on('drawend', this.onDrawEnd);
      this.map.addInteraction(this.draw);
    },
    toggleInterationMouseWheelZoom() {
      if (
        typeof this.map != 'undefined' &&
        typeof this.map.interactions != 'undefined'
      ) {
        this.map
          .getInteractions()
          .getArray()
          .forEach((interaction, i) => {
            if (i === 7) {
              interaction.values_.active = false;
            }
          });
      }
    },
    removeInteractions() {
      this.map
        .getInteractions()
        .getArray()
        .forEach((interaction, i) => {
          if (i > 8) {
            this.map.removeInteraction(interaction);
            this.typeSelected = ';';
          }
        });
    },
    clearMeasurements() {
      this.removeInteractions();
      this.map
        .getOverlays()
        .getArray()
        .slice()
        .forEach((overlay) => {
          if (overlay.getOptions().type == 'measure') {
            this.map.removeOverlay(overlay);
          }
        });
      this.vector_layer.getSource().clear();
    },
    onDrawStart: function (e) {
      class MeasureOverlays {
        constructor(
          map,
          element = document.getElementById('div'),
          offset = [0, -15],
          positioning = 'bottom-center',
          className = 'ol-tooltip2 ol-tooltip-measure',
        ) {
          this.map = map;
          this.overlay = new Overlay({
            type: 'measure',
            element: element,
            offset: offset,
            positioning: positioning,
            className: className,
          });
          this.map.addOverlay(this.overlay);
        }
      }

      //It will store the coordinates length of geometry
      this.coordinates_length = 0;

      //partDistanceOverlay is used to display the label of distance measurements on each segment of Line and Polygon geomtry
      this.partDistanceOverlay = null;

      //totalAreaDistanceOverlay is used to display the total distance if geomtery is LineString or it will display the area if geomtry is Polygon
      this.totalAreaDistanceOverlay = new MeasureOverlays(this.map).overlay;

      //lastPartLineOverlay is used to display the distance measurement of last segment of Polygon which is its last two coordinates
      this.lastPartLineOverlay = new MeasureOverlays(this.map).overlay;

      //Binding onGeomChange function with drawing feature
      e.feature.getGeometry().on('change', this.onGeomChange);
    },
    onDrawEnd: function (e) {
      //Add drawn geometry to vector layer
      this.vector_layer.getSource().addFeature(e.feature);
    },
    onGeomChange: function (e) {
      class MeasureOverlays {
        constructor(
          map,
          element = document.getElementById('div'),
          offset = [0, -15],
          positioning = 'bottom-center',
          className = 'ol-tooltip2 ol-tooltip-measure',
        ) {
          this.map = map;
          this.overlay = new Overlay({
            type: 'measure',
            element: element,
            offset: offset,
            positioning: positioning,
            className: className,
          });
          this.map.addOverlay(this.overlay);
        }
      }

      let geomType = e.target.getType();
      let coordinates = e.target.getCoordinates();
      if (geomType == 'Polygon') {
        coordinates = e.target.getCoordinates()[0];
      }

      //This logic will check if the new coordinates are added to geometry. If yes, then It will create a overlay for the new segment
      if (coordinates.length > this.coordinates_length) {
        this.partDistanceOverlay = new MeasureOverlays(this.map).overlay;
        this.coordinates_length = coordinates.length;
      } else {
        this.coordinates_length = coordinates.length;
      }

      let partLine = new LineString([
        coordinates[this.coordinates_length - 2],
        coordinates[this.coordinates_length - 1],
      ]);

      if (geomType == 'Polygon') {
        partLine = new LineString([
          coordinates[this.coordinates_length - 3],
          coordinates[this.coordinates_length - 2],
        ]);
      }

      //the calculates the length of a segment and position the overlay at the midpoint of it
      this.calDistance(
        this.partDistanceOverlay,
        partLine.getFlatMidpoint(),
        partLine.getLength(),
      );

      //if geometry is LineString and coordinates_length is greater than 2, then calculate the total length of the line and set the position of the overlay at last coordninates
      if (
        geomType == 'LineString' &&
        this.coordinates_length > 2 &&
        e.target.getLength() >
          new LineString([coordinates[0], coordinates[1]]).getLength()
      ) {
        this.calDistance(
          this.totalAreaDistanceOverlay,
          coordinates[this.coordinates_length - 1],
          getLength(e.target),
        );
      }

      //If geometry is Polygon, then it will create the overlay for area measurement and last segment of it which is its first and last coordinates.
      if (geomType == 'Polygon' && this.coordinates_length > 3) {
        this.calArea(
          this.totalAreaDistanceOverlay,
          e.target.getFlatInteriorPoint(),
          getArea(e.target),
        );
        partLine = new LineString([
          coordinates[this.coordinates_length - 2],
          coordinates[this.coordinates_length - 1],
        ]);
        this.calDistance(
          this.lastPartLineOverlay,
          partLine.getFlatMidpoint(),
          getLength(partLine),
        );
      }
    },
    calDistance: function (overlay, overlayPosition, distance) {
      distance *= 100000;
      if (parseInt(distance) == 0) {
        overlay.setPosition([0, 0]);
      } else {
        overlay.setPosition(overlayPosition);
        if (distance >= 1000) {
          overlay.element.innerHTML = (distance / 1000).toFixed(2) + ' km';
        } else {
          overlay.element.innerHTML = distance.toFixed(2) + ' m';
        }
      }
    },
    calArea: function (overlay, overlayPosition, area) {
      area *= 10000000000;
      if (parseInt(area) == 0) {
        overlay.setPosition([0, 0]);
      } else {
        overlay.setPosition(overlayPosition);
        if (area >= 10000) {
          overlay.element.innerHTML =
            Math.round((area / 1000000) * 100) / 100 + ' km<sup>2<sup>';
        } else {
          overlay.element.innerHTML =
            Math.round(area * 100) / 100 + ' m<sup>2<sup>';
        }
      }
    },
    onMapReady() {
      if (this.managementRole) {
        this.initialCenter = {
          center: getCenter(this.managementRole),
          zoom: 8,
          minZoom: 8,
        };
        this.setCenterReset();
      }

      if (!this.gotSearchUrl && this.searchResult) {
        this.getSearchResult(this.searchResult);
      }
      this.$emit('onMapReady', {map: this.map, view: this.view});
    },
    checkMapModal() {
      const modal = window.localStorage.getItem(this.keyModal);
      modal === 'true' ? (this.dialog = true) : (this.dialog = false);
      if (this.dialog) {
        setTimeout(() => {
          this.mapModal();
        }, 2500);
      }
    },
    mapModal() {
      const coordinate = this.map.getView().getCenter();
      const container = document.getElementById('popup');
      const content = document.getElementById('popup-content');
      const closer = document.getElementById('popup-closer');
      const overlay = new Overlay({
        element: container,
        position: coordinate,
        positioning: 'center-center', // 'bottom-center'
        stopEvent: false,
        autoPan: {
          animation: {
            duration: 250,
          },
        },
      });
      closer.onclick = function () {
        overlay.setPosition(undefined);
        closer.blur();
        this.dialog = false;
        const container = document.getElementById('popup');
        container.style.visibility = 'hidden';
        container.style.display = 'none';
        window.localStorage.setItem(LOCAL_STORAGE_MODAL_MAP_INFO, false);
        return false;
      };
      const firstLine =
        ' Dê um duplo clique no mapa para ativar o zoom pelo mouse.';
      const secondLine =
        'Ao sair da área do mapa, o zoom pelo mouse será desativado.';
      container.style.visibility = 'visible';
      container.style.display = 'block';
      content.innerHTML = `<span style="color: #FFF"><span style="color: #FFD600;" class="material-icons">info_outline</span>${firstLine}<br><span style="color: #fff">${secondLine}</span></span>`;
      this.map.addOverlay(overlay);
    },
    changeEnabledSublayer(value) {
      this.$emit('changeEnabledSublayer', value);
    },
    changeOpacitySublayer(value) {
      this.$emit('changeOpacitySublayer', value);
    },
    async getSearchResult(url) {
      const response = await loadFeatures(url);
      const feature = response.data;
      if (this.managementRole) {
        this.setCenterReset();
      } else {
        this.setMapbbox(feature.bbox);
      }
      this.gotSearchUrl = true;
    },
    async setMapbbox(bbox) {
      let resolution = this.view.getResolutionForExtent(bbox);
      let zoom = this.view.getZoomForResolution(resolution);
      zoom = zoom - 1;
      let center = getCenter(bbox);
      configZoom(this.view, zoom, center);
      await this.checkMapModal();
    },
    setCenterReset() {
      const {zoom, center, minZoom} = this.initialCenter;
      configZoom(this.view, zoom, center, minZoom);
    },
    fullscreenchanged() {
      if (document.fullscreenElement) {
        this.newFullscreen = true;
      } else {
        this.newFullscreen = false;
      }
    },
    toggleFullscreen() {
      this.newFullscreen = !this.newFullscreen;
      const element = document.getElementById('map-contaier-to-fullscreen');
      if (
        !document.fullscreenElement &&
        !document.mozFullScreenElement &&
        !document.webkitFullscreenElement &&
        !document.msFullscreenElement
      ) {
        if (element.requestFullscreen) {
          element.requestFullscreen();
        } else if (element.mozRequestFullScreen) {
          element.mozRequestFullScreen();
        } else if (element.webkitRequestFullscreen) {
          element.webkitRequestFullscreen();
        } else if (element.msRequestFullscreen) {
          element.msRequestFullscreen();
        }
      } else {
        if (document.exitFullscreen) {
          document.exitFullscreen();
        } else if (document.mozCancelFullScreen) {
          document.mozCancelFullScreen();
        } else if (document.webkitExitFullscreen) {
          document.webkitExitFullscreen();
        } else if (document.msExitFullscreen) {
          document.msExitFullscreen();
        }
      }
    },
  },
};
</script>

<style scoped>
.map:-webkit-full-screen {
  height: 100%;
  margin: 0;
}
.map:-ms-fullscreen {
  height: 100%;
}
.map:fullscreen {
  height: 100%;
}

.map-sidebar {
  position: absolute;
  margin-top: 53px;
  z-index: 10;
}
.map-bottom-bar {
  position: absolute;
  bottom: 8px;
  left: 8px;
  z-index: 10;
}
/deep/ .ol-full-screen {
  right: unset;
  top: 3.8em;
  left: 0.5em;
}
/deep/ .ol-scale-line-inner-inner {
  color: black;
  font-size: 14px;
  font-weight: 500;
  border-bottom: black solid 1px;
  border-left: black solid 1px;
  border-right: black solid 1px;
}
/deep/ .custom-mouse-position {
  color: black;
  font-size: 14px;
  font-weight: 500;
}
/deep/ .ol-control button {
  background-color: white;
  color: #424242;
  box-shadow: 0 0 0.2em #424242;
}
/deep/ .ol-control button:hover {
  background-color: lightgrey;
}
.tooltip {
  width: 300px;
  background-color: black;
  color: #fff;
  text-align: center;
  border-radius: 6px;
  padding: 8px;
  opacity: 0.8;
  position: absolute;
  transition: 0.5s all ease;
  transition-delay: 0.5s;
  z-index: 1000;
}
/deep/.ol-tooltip2 {
  position: relative;
  background: rgba(0, 0, 0, 1);
  border-radius: 4px;
  color: white;
  padding: 4px 8px;
  opacity: 0.7;
  white-space: nowrap;
  font-size: 12px;
  cursor: default;
  user-select: none;
}
/deep/.ol-tooltip-measure {
  opacity: 1;
  font-weight: bold;
}
/deep/.ol-tooltip-static {
  background-color: #ffcc33;
  color: black;
  border: 1px solid white;
}
/deep/.ol-tooltip-measure:before,
/deep/.ol-tooltip-static:before {
  border-top: 6px solid rgba(0, 0, 0, 1);
  border-right: 6px solid transparent;
  border-left: 6px solid transparent;
  content: '';
  position: absolute;
  bottom: -6px;
  margin-left: -7px;
  left: 50%;
}
/deep/.ol-tooltip-static:before {
  border-top-color: #ffcc33;
}
hr.solid {
  border-top: 3px solid #fff;
}
.ol-popup {
  background-color: rgba(33, 42, 53, 0.8);
  box-shadow: 0 1px 4px rgba(0, 0, 0, 0.2);
  padding: 15px;
  border-radius: 10px;
  border: 1px solid #cccccc;
  bottom: 12px;
  min-width: 280px;
  z-index: inherit;
}
.ol-popup:after {
  border-top-color: white;
  border-width: 10px;
  left: 48px;
  margin-left: -10px;
}
.ol-popup:before {
  border-top-color: #cccccc;
  border-width: 11px;
  left: 48px;
  margin-left: -11px;
}
.ol-popup-closer {
  text-decoration: none;
  position: absolute;
  top: 2px;
  right: 8px;
}
.ol-popup-closer:after {
  content: '✖';
}

.scale-line-text {
  font-family: Roboto;
  font-style: normal;
  font-weight: normal;
  font-size: 14px;
  line-height: 18px;
  color: #262626;
}

.atribution-text {
  font-family: Roboto;
  font-style: normal;
  font-weight: 500;
  font-size: 14px;
  line-height: 18px;
  color: var(--v-secondary-lighten1);
}

.map-fullscreen {
  background-color: #212a35;
  position: absolute;
  right: 10px;
  top: 30px;
  z-index: 9999999999;
  max-width: 400px;
  border-radius: 6px;
}
.map-not-fullscreen {
  background-color: #212a35;
}
</style>
